import { useEffect } from "react";
import { signIn } from "@pagemates/shared/copy";

const txt = signIn.devLogin;

// Development only: /dev-login?token=…&next=/clubs/x stores a dev session
// token (from GET /api/dev/login) and continues. Not routed in production builds.
export function DevLogin() {
  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    const token = p.get("token");
    try { if (token) localStorage.setItem("pm_token", token); else localStorage.removeItem("pm_token"); } catch { /* ignore */ }
    window.location.replace(p.get("next") ?? "/clubs");
  }, []);
  return <main className="page"><p className="muted small">{txt.signingIn}</p></main>;
}
